export const INFO_CARD_USER_ACTIONS = 1;
export const INFO_CARD_USER_ACTIVITY = 2;
export const INFO_CARD_PROFILE = 3;
export const INFO_CARD_USER_CHALLENGE = 4;
export const INFO_CARD_CHALLENGE_UPDATE = 5;
